"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizard = void 0;
const react_1 = require("react");
function useWizard(stages) {
    const [stageIndex, setStageIndex] = (0, react_1.useState)(0);
    const goForward = (0, react_1.useCallback)(() => {
        setStageIndex(index => {
            if (stages.length - 1 === index) {
                return index;
            }
            return index + 1;
        });
    }, [setStageIndex, stages]);
    const goBack = (0, react_1.useCallback)(() => {
        setStageIndex(index => {
            if (index === 0) {
                return index;
            }
            return index - 1;
        });
    }, [setStageIndex, stages]);
    const goToStage = (0, react_1.useCallback)((index) => {
        if (index > stages.length - 1)
            return;
        if (index < 0)
            return;
        setStageIndex(index);
    }, [setStageIndex, stages]);
    return {
        goForward,
        goBack,
        goToStage,
        stageIndex,
        stage: stages[stageIndex]
    };
}
exports.useWizard = useWizard;
//# sourceMappingURL=useWizard.js.map